import styled from "styled-components";
import {Skeleton} from "antd";

export const SkeletonView = styled((props:any) => {
    return (
        <Skeleton.Node active {...props}>
            <div/>
        </Skeleton.Node>
    )
})`
`;
export const SkeletonViewImage = styled(SkeletonView)`
  position: absolute;
  width: 100% !important;
  height: 100% !important;
  background-color: rgba(255, 255, 255, 0.2);
`;
export const SkeletonViewButton = styled(SkeletonView)`
  border-radius: 50px;
  width: 238px !important;
  height: 48px !important;
  background-color: rgba(255, 255, 255, 0.2);
`;

export const SkeletonViewText = styled(({lines, itemStyle, style}) => {
    return (
        <div style={{
            display: "flex",
            width: '100%',
            flexDirection: 'column',
            marginBottom: 6,
            marginTop: 6, ...(style || {})
        }}>
            {lines?.map(x => {
                return (
                    <SkeletonView key={x} style={{
                        borderRadius: 6,
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginBottom: 4,
                        width: '100%',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        height: 14, ...(itemStyle || {})
                    }}/>)
            })}
        </div>
    )
})`
`;

